import React from 'react';
import { StandardModal } from 'pureUi/Modal';
import { SvgIcon } from 'ui/SvgIcon';
import ExclamationTriangleIcon from 'ui/Icons/tabler/exclamation-triangle.component.svg';

interface IVoucherV2DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export const VoucherV2DeleteModal: React.FC<IVoucherV2DeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <StandardModal
      className="delete-modal"
      frameClassName="w-500px px-9 py-8 border-4 border-solid border-yellow-50 rounded-xl"
      showCloseButton={false}
      removePadding={true}
    >
      <div className="flex justify-between items-center">
        <SvgIcon IconComponent={ExclamationTriangleIcon} className="w-14 h-14 fill-yellow-50" />
        <div className="w-5/6">
          <h1 className="text-black text-lg font-pt-sans m-0">Are you sure you want to delete this file?</h1>
        </div>
      </div>

      <div className="flex justify-between mt-6">
        <button
          className="confirm block w-full mr-3 border-solid hover:bg-brown-120 cursor-pointer border-2 border-brown-100 hover:border-brown-120 text-base font-pt-sans p-2 rounded font-bold bg-brown-100 text-white tracking-wider outline-none disabled:text-gray-80 disabled:bg-gray-20 disabled:border-gray-20 disabled:cursor-default"
          onClick={onConfirm}
          disabled={isLoading}
        >
          Delete
        </button>
        <button
          className="cancel block w-full ml-3 border-solid hover:bg-brown-20 cursor-pointer border-2 border-brown-100 text-base font-pt-sans p-2 rounded font-bold bg-white text-brown-100 tracking-wider outline-none disabled:text-gray-80 disabled:border-gray-20 disabled:bg-white disabled:cursor-default"
          onClick={onClose}
          disabled={isLoading}
        >
          Cancel
        </button>
      </div>
    </StandardModal>
  );
};